
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import TahsilatTuruPicker from "@/components/pickers/TahsilatTuruPicker.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import Kur from "@/components/inputs/Kur.vue";
import {TahsilatTuru, TahsilatTuruLabel} from "@/enum/TahsilatTuru";
import TakipBorcluPicker from "@/components/pickers/TakipBorcluPicker.vue";
import TahsilHarciPicker from "@/components/pickers/TahsilHarciPicker.vue";
import AltTahsilatTuruPicker from "@/components/pickers/AltTahsilatTuruPicker.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import {TakipDurumu} from "@/enum/TakipDurumu";
import {TakipEntity} from "@/entity/TakipEntity";
import {HarcTuruEntity} from "@/entity/HarcTuruEntity";
import {AxiosResponse} from "axios";
import {HarcDonemiEntity} from "@/entity/HarcDonemiEntity";
import {AltTahsilatTuru} from "@/enum/AltTahsilatTuru";

@Component({
  components: {
    Kur,
    FormWrapper,
    AltTahsilatTuruPicker,
    TahsilHarciPicker,
    TakipBorcluPicker,
    Tutar,
    TahsilatTuruPicker,
    Dates,
    ParaBirimiPicker
  }
})
export default class TaksitTahsilatDonustur extends Mixins(ObjectInputMixin) {
  @Prop({required: true}) takip!: TakipEntity;
  @Ref('takipBorcluPicker') readonly takipBorcluPicker!: TakipBorcluPicker;

  TahsilatTuru = TahsilatTuru;
  ParaBirimi = ParaBirimi;
  TakipDurumu = TakipDurumu;
  items: Array<HarcDonemiEntity> = [];
  selectedItem: HarcDonemiEntity = new HarcDonemiEntity();
  altTahsilatTuru = AltTahsilatTuru;
  takipSonrasi: boolean = false;
  isHesaplaniyor: boolean = false;
  debounceTimer: number | null = null;

  get tarihKontrol() {
    return new Date(this.localValue.tarih).getTime() > new Date(this.takip.takip_tarihi).getTime();
  }

  get isHideButtonsSubmit() {
    return this.takip.takip_durumu === TakipDurumu.acilmamis && this.tarihKontrol;
  }

  @Watch('localValue.tahsilat_turu')
  changeTahsilatTuru() {
    if (this.localValue.tahsilat_turu !== this.TahsilatTuru.icra) {
      this.localValue.cezaevi_harci = 0;
    }
    if (this.takipSonrasi && this.localValue.tutar) {
      this.hesaplaHarciApiUzerinden();
    } else {
      this.netTutarHesapla();
    }
  }

  birGunCikar() {
    const takipTarihi = new Date(this.takip.takip_tarihi);
    takipTarihi.setDate(takipTarihi.getDate() - 1);
    return takipTarihi.toISOString().substr(0, 10);
  }

  get filterTurler() {
    if (!this.takipSonrasi) {
      return Object.values(TahsilatTuru).filter(turu => turu !== TahsilatTuru.icra);
    }
    return Object.values(TahsilatTuru);
  }

  get filterTurlerLabel() {
    if (!this.takipSonrasi) {
      return Object.values(TahsilatTuruLabel)
          .filter((label, index) => Object.values(TahsilatTuru)[index] !== TahsilatTuru.icra);
    }
    return Object.values(TahsilatTuruLabel);
  }


  @Watch('localValue.tarih')
  onTahsilatTarihiChange() {
    const isTakipSonrasi = new Date(this.localValue.tarih).getTime() >= new Date(this.takip.takip_tarihi).getTime();
    if (this.takipSonrasi !== isTakipSonrasi) {
      this.takipSonrasi = isTakipSonrasi;
      if (this.takipSonrasi) {
        if (!this.localValue.tahsil_harci_orani) this.localValue.tahsil_harci_orani = "4.55";
        this.hesaplaHarciApiUzerinden();
      } else {
        this.localValue.tahsil_harci = 0;
        this.localValue.cezaevi_harci = 0;
        this.localValue.tahsil_harci_orani = "0.00";
        this.netTutarHesapla();
      }
    }
    this.input();
  }

  @Watch('localValue.tutar')
  onTutarChange() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    if (!this.takipSonrasi) {
      this.localValue.net_tutar = Number(this.localValue.tutar);
      this.input();
    } else {
      this.debounceTimer = setTimeout(() => {
        this.hesaplaHarciApiUzerinden();
      }, 500);
    }
  }

  mounted() {
    this.takipSonrasi = this.takip.takip_durumu !== TakipDurumu.acilmamis;
    if (!this.localValue.tutar) this.localValue.net_tutar = 0;

    if (!this.localValue?.id) {
      this.localValue.tarih = new Date();
      this.localValue.giris_tarihi = new Date();
      this.localValue.alt_tahsilat_turu_id = null;
      if (this.takipSonrasi && !this.localValue.tahsil_harci_orani) {
        this.localValue.tahsil_harci_orani="4.55"
      }
    }
    this.getHarcDonemi();
    if(this.localValue.tahsil_harci_orani==undefined){
      this.localValue.tahsil_harci_orani="4.55"
    }

    // Varolan kayıt açıldığında veya takip sonrasıysa harçları hesapla
    if (this.takipSonrasi && this.localValue.tutar) {
      this.hesaplaHarciApiUzerinden();
    }
  }

  onKurChange() {
    if (this.takipSonrasi) {
      this.hesaplaHarciApiUzerinden();
    } else {
      this.input();
    }
  }

  async hesaplaHarciApiUzerinden() {
    if (!this.takipSonrasi || !this.localValue.tutar) {
      this.localValue.tahsil_harci = 0;
      this.localValue.cezaevi_harci = 0;
      this.netTutarHesapla();
      return;
    }
    this.isHesaplaniyor = true;
    if (this.localValue.para_birimi_id == this.ParaBirimi.TRY) this.localValue.kur = 1;

    try {
      // Tahsil harcını hesapla
      const tahsilHarciResponse = await this.$http.post('/api/v1/takip/' + this.takip.id + '/tahsil-harci-hesapla', {
        tahsilat_id: this.localValue.id ?? null,
        tutar: this.localValue.tutar,
        tahsil_harci_orani: this.localValue.tahsil_harci_orani,
        kur: this.localValue.kur
      });

      const harcTutari = tahsilHarciResponse.data?.tahsil_harci_tutari ?? 0;
      this.localValue.tahsil_harci = Number(harcTutari).toFixed(2);

      // Cezaevi harcını hesapla (sadece icra tahsilatı için)
      if (this.localValue.tahsilat_turu === this.TahsilatTuru.icra && parseFloat(this.localValue.tahsil_harci_orani || "0") > 0) {
        const cezaeviHarciResponse = await this.$http.post('/api/v1/takip/' + this.takip.id + '/cezaevi-harci-hesapla', {
          tahsilat_id: this.localValue.id ?? null,
          tutar: this.localValue.tutar,
          tahsil_harci_orani: this.localValue.tahsil_harci_orani,
          kur: this.localValue.kur
        });

        const cezaeviHarci = cezaeviHarciResponse.data?.cezaevi_harci_tutari ?? 0;
        this.localValue.cezaevi_harci = Number(cezaeviHarci);
      } else {
        this.localValue.cezaevi_harci = 0;
      }
    } catch (error) {
      console.error("Harç hesaplama API hatası:", error);
      this.localValue.tahsil_harci = 0;
      this.localValue.cezaevi_harci = 0;
    } finally {
      this.netTutarHesapla();
      this.isHesaplaniyor = false;
      this.input();
    }
  }

  netTutarHesapla() {
    let tutar = this.localValue.tutar ?? 0;
    if (typeof tutar == 'string') tutar = Number(tutar);
    if (this.localValue.para_birimi_id != ParaBirimi.TRY && this.localValue.kur) {
      tutar *= this.localValue.kur;
    }

    if (!this.takipSonrasi) {
      this.localValue.net_tutar = this.localValue.tutar;
      return;
    }

    let tahsilHarci = Number(this.localValue.tahsil_harci || 0);
    let cezaeviHarci = Number(this.localValue.cezaevi_harci || 0);

    let netTutar = tutar - tahsilHarci - cezaeviHarci;

    if (this.localValue.para_birimi_id != ParaBirimi.TRY && this.localValue.kur) {
      netTutar /= this.localValue.kur;
    }

    this.localValue.net_tutar = isNaN(netTutar) ? 0 : netTutar;
  }

  getHarcDonemi() {
    this.$http.get("/api/v1/tahsilat-harclar").then((response) => {
      this.items = response.data;
    });
  }

  get tahsilHarciOranlari() {
    let tahsilHarc: any = [];
    this.items.forEach((item: any) => {
      if (item.oran == 2.275) {
        tahsilHarc.push(Number(item.oran).toFixed(3).toString());
      } else {
        tahsilHarc.push(Number(item.oran).toFixed(2).toString());
      }
    });
    tahsilHarc.push("0.00"); // 0.00'ı döngü dışında, sona eklemek daha doğru
    tahsilHarc = [...new Set(tahsilHarc)]; // Tekrarları engelle
    return tahsilHarc;
  }

  save() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);

    // borclu_id bir obje ise sadece ID'yi al
    if (typeof this.localValue.borclu_id === 'object' && this.localValue.borclu_id !== null) {
      this.localValue.borclu_id = (this.localValue.borclu_id as any).id;
    }

    let taksitTahsilatDonusturPayload= {
      id:this.localValue.id,
      tutar: this.localValue.tutar,
    }
    this.$http.post("/api/v1/takip/" + this.takip?.id + "/tahsilat/", this.localValue).then(() => {
      this.$http.put("/api/v1/takip/" + this.takip?.id + "/taksit-tahsilat-donustur", taksitTahsilatDonusturPayload);
      this.$emit('onSuccess');
      this.$emit('load');
    });
  }
}
